import { useQuery } from '@tanstack/react-query';
import { fetchUser, fetchUsersByKey, fetchUserMarksByIds, userKeys } from '../api/userAPI';
import { handleError } from '../managers/errorHandler';

export { userKeys };

/**
 * 用户查询hooks - 统一命名规范
 */

/**
 * 获取当前用户详情
 */
export const useUserQuery = () => {
  return useQuery({
    queryKey: userKeys.detail('current'),
    queryFn: async () => {
      try {
        const response = await fetchUser();
        const userData = response?.content || response;
        
        if (userData) {
          return userData;
        } else {
          return null;
        }
      } catch (error) {
        handleError(error, { context: 'useUserQuery', showToast: false });
        throw error;
      }
    },
    staleTime: 2 * 60 * 1000,
  });
};

/**
 * 根据关键字搜索用户
 */
export const useUsersSearchQuery = (key: string) => {
  return useQuery({
    queryKey: userKeys.search(key),
    queryFn: async () => {
      try {
        const response = await fetchUsersByKey(key);
        const result = response?.content || response;
        
        if (result) {
          return result;
        } else {
          return null;
        }
      } catch (error) {
        handleError(error, { context: 'useUsersSearchQuery', showToast: false });
        throw error;
      }
    },
    enabled: !!key,
    staleTime: 2 * 60 * 1000,
  });
};

/**
 * 根据ID列表获取用户标记
 */
export const useUserMarksQuery = (userIds: string[]) => {
  return useQuery({
    queryKey: userKeys.marks(),
    queryFn: async () => {
      try {
        const numericIds = userIds.map(id => Number(id)).filter(id => !isNaN(id));
        const response = await fetchUserMarksByIds(numericIds);
        const userMarksData = response || [];
        
        if (userMarksData) {
          return userMarksData;
        } else {
          return null;
        }
      } catch (error) {
        handleError(error, { context: 'useUserMarksQuery', showToast: false });
        throw error;
      }
    },
    enabled: userIds && userIds.length > 0,
    staleTime: 2 * 60 * 1000,
  });
};